import httpCommon from "./http-common";

// Get supplier
const getSupplier = (publicId: string) => {
  return httpCommon.get(`/v1/get/supplier/${publicId}`);
};

// Get all suppliers
const getAllSuppliers = (businessId: number) => {
  return httpCommon.get(`/v1/get/suppliers/${businessId}`);
};

// Get supplier count
const getAllSuppliersCount = () => {
  return httpCommon.get("/v1/get/count/suppliers");
};

const getSupplierRoles = () => {
  return httpCommon.get("/v1/get/supplierRoles");
};

const getSupplierRolesForSupplier = (supplierId: number) => {
  return httpCommon.get(`/v1/get/supplierRoles/${supplierId}`);
};

// Add supplier
const addSupplier = (businessId: number, data: any) => {
  return httpCommon.post(`/v1/add/supplier/${businessId}`, data);
};

const createSupplierRole = (data: any, supplierId: number) => {
  return httpCommon.post(`/v1/add/supplierRole/${supplierId}`, data);
};

const searchSupplier = (businessId: number, searchTerm: string) => {
  return httpCommon.get(`/v1/search/suppliers/${businessId}/${searchTerm}`);
};

// Update specific supplier
const updateSpecificSupplier = (id: number, data: any) => {
  return httpCommon.put(`/v1/update/supplier/${id}`, data);
};

// Update self supplier
const updateSupplier = (data: any) => {
  return httpCommon.put(`/v1/update/supplier`, data);
};

// Delete supplier
const deleteSupplier = (publicId: string) => {
  return httpCommon.delete(`/v1/delete/supplier/${publicId}`);
};

const deleteSupplierRole = (roleId: number) => {
  return httpCommon.delete(`/v1/delete/supplierRole/${roleId}`);
};

// Admin functions
const getSupplierAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/supplier");
};

const getAllSuppliersAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/suppliers");
};

const getAllSuppliersCountAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/count/suppliers");
};

const getSupplierRolesAsAdminUser = () => {
  return httpCommon.get("/v1/admin/get/supplierRoles");
};

const getSupplierRolesForSupplierAsAdminUser = (supplierId: number) => {
  return httpCommon.get(`/v1/admin/get/supplierRoles/${supplierId}`);
};

const addSupplierAsAdminUser = (data: any) => {
  return httpCommon.post("/v1/admin/add/supplier", data);
};

const createSupplierRoleAsAdminUser = (data: any, supplierId: number) => {
  return httpCommon.post(`/v1/admin/add/supplierRole/${supplierId}`, data);
};

const updateSpecificSupplierAsAdminUser = (id: number, data: any) => {
  return httpCommon.put(`/v1/admin/update/supplier/${id}`, data);
};

const updateSupplierAsAdminUser = (data: any) => {
  return httpCommon.put(`/v1/admin/update/supplier`, data);
};

const deleteSupplierAsAdminUser = (id: number) => {
  return httpCommon.delete(`/v1/admin/delete/supplier/${id}`);
};

const deleteSupplierRoleAsAdminUser = (roleId: number) => {
  return httpCommon.delete(`/v1/admin/delete/supplierRole/${roleId}`);
};

const SupplierService = {
    getSupplier,
    getAllSuppliers,
    getAllSuppliersCount,
    getSupplierRoles,
    getSupplierRolesForSupplier,
    addSupplier,
    createSupplierRole,
    updateSpecificSupplier,
    updateSupplier,
    searchSupplier,
    deleteSupplier,
    deleteSupplierRole,
    getSupplierAsAdminUser,
    getAllSuppliersAsAdminUser,
    getAllSuppliersCountAsAdminUser,
    getSupplierRolesAsAdminUser,
    getSupplierRolesForSupplierAsAdminUser,
    addSupplierAsAdminUser,
    createSupplierRoleAsAdminUser,
    updateSpecificSupplierAsAdminUser,
    updateSupplierAsAdminUser,
    deleteSupplierAsAdminUser,
    deleteSupplierRoleAsAdminUser
};
export default SupplierService;